import React, { useState } from "react";
import { FullModal } from "../fullModal";
import { RMCCard } from "../../../../../components/world/rmc/card";
import { Input } from "../../../../../components/world/rmc/input/input";
import Button from "../../../../../components/world/rmc/Button";
import { RewardSuccess } from "./rewardSuccess";

export const RewardForm = ({ setIsOpen }) => {
  const [isClaimed, setIsClaimed] = useState(false);

  return (
    <FullModal>
      <div className="px-4 pt-16 h-full overflow-y-scroll hidden-scrollbar">
        <div className="text-center mb-6">
          <p className="text-2xl text-white font-semibold">
            Once Again Congratulations!
          </p>
          <span className="text-xs text-[#FFFFFF80]">
            Fill out the form below with your correct information to claim your
            reward
          </span>
        </div>
        <RMCCard className="flex flex-col gap-9 my-10">
          <Input
            inputClass="bg-[#111522]"
            label="Full Name"
            placeholder="Enter your full name"
          />
          <Input
            inputClass="bg-[#111522]"
            label="Phone Number"
            placeholder="Enter your valid phone"
            type="number"
          />
          <Input
            inputClass="bg-[#111522]"
            label="Email"
            placeholder="Enter your valid  email address"
          />
          <Input
            inputClass="bg-[#111522]"
            label="Delivery Address"
            placeholder="Enter your valid address"
          />
        </RMCCard>
        <div className="w-full flex flex-col gap-5 pb-10">
          <Button
            onClick={() => setIsClaimed(true)}
            text="Submit Claim"
            className="text-lg py-[18px]"
          />
          <Button
            onClick={() => setIsOpen(false)}
            text="Cancel"
            className="text-lg py-[18px] !bg-[#1A1F33] !text-[#FFFFFFBF]"
          />
        </div>
      </div>
      {isClaimed && <RewardSuccess />}
    </FullModal>
  );
};
